<p-card class="h-full">
  <!-- Header Template -->
  <ng-template pTemplate="header">
    @if (story.coverImage) {
      <img 
        [src]="story.coverImage" 
        [alt]="story.title"
        class="w-full h-48 object-cover"
      />
    } @else {
      <div class="h-48 bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
        <i class="pi pi-bookmark text-white text-4xl"></i>
      </div>
    }
  </ng-template>

  <!-- Content Template -->
  <ng-template pTemplate="content">
    <!-- Title -->
    <h3 class="text-heading-md mb-2 line-clamp-2">
      {{ story.title }}
    </h3>

    <!-- Description -->
    <p class="text-body-sm text-secondary mb-4 line-clamp-3">
      {{ story.description }}
    </p>

    <!-- Link URL -->
    <div class="mb-4">
      <a 
        [href]="story.linkUrl" 
        target="_blank" 
        rel="noopener noreferrer"
        class="text-primary text-caption-lg font-medium inline-flex items-center gap-1">
        {{ 'successStories.viewStory' | translate }}
        <i class="pi pi-external-link text-xs"></i>
      </a>
    </div>
  </ng-template>

  <!-- Footer Template -->
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        icon="pi pi-pencil"
        size="small"
        [rounded]="true"
        (onClick)="onEdit()"
        [ariaLabel]="'successStories.editStory' | translate">
      </p-button>

      <p-button
        icon="pi pi-trash"
        size="small"
        [rounded]="true"
        severity="danger"
        (onClick)="onRemove()"
        [ariaLabel]="'successStories.removeStory' | translate">
      </p-button>
    </div>
  </ng-template>
</p-card>